// extracted by mini-css-extract-plugin
export default {"articleTitle":"noticeArtice_articleTitle__Bpq8h","content":"noticeArtice_content__IXdEC"};